/**
 * The SVG attribute strings both platforms' plans draw with, from
 * screen-space points: the `points` of a polygon or polyline, and the `d` of
 * closed rings.
 */
import type { Point } from '@kaiizen/kai-floor-plan';

/** A `points` attribute: `x,y` pairs, space separated. */
export const svgPoints = (points: readonly Point[]): string => points.map(point => `${point.x},${point.y}`).join(' ');

/**
 * The `d` of closed rings: a footprint and its holes, for an evenodd fill.
 * A ring of fewer than two points draws nothing.
 */
export const ringsPath = (rings: readonly (readonly Point[])[]): string =>
  rings
    .filter(ring => ring.length > 1)
    .map(ring => ring.map((point, index) => `${index ? 'L' : 'M'}${point.x} ${point.y}`).join(' ') + ' Z')
    .join(' ');
